export default __webpack_public_path__ + "static/media/product_test_discovery_bte.e3e1ae14.jpg";